__turbopack_context__.v({
  "content": "modal-module__KYXbeW__content",
  "header": "modal-module__KYXbeW__header",
  "overlay": "modal-module__KYXbeW__overlay",
});
